/**
 * Integrations Tab Prompt Builder
 *
 * Generates an API catalogue / integration patterns diagram
 * from technical services and relationship data.
 */

import type { BulkEAImport } from '../../canister-client';
import type { ChatMessage } from '../../canister-client';
import { baseSvgRules, summarizeEntities } from './base-svg-prompt';

export function buildIntegrationsPrompt(data: BulkEAImport): ChatMessage[] {
    const techSvcs = summarizeEntities(data.technical_services, [
        'name', 'application', 'service_type', 'api_interface', 'availability_sla',
    ]);
    const rels = summarizeEntities(data.relationships, [
        'source_type', 'source_id', 'relationship_type', 'target_type', 'target_id',
    ]);

    return [
        {
            role: 'user',
            content: `${baseSvgRules()}

DIAGRAM TYPE: Integration Patterns / API Catalogue

DATA - Technical Services (APIs):
${techSvcs}

DATA - Relationships:
${rels}

INSTRUCTIONS:
- Create an API catalogue layout showing integration patterns.
- Group APIs by their parent application.
- Each API card shows: name, type (REST/SOAP/gRPC), interface, SLA.
- Draw integration flows between source and target systems.
- Use protocol badges (colored pills): REST=blue, SOAP=amber, gRPC=purple, File=green.
- Show data flow direction with arrows.
- Add a title "Integration Patterns & API Catalogue" at the top.
- Include counts per integration type in a summary bar.`,
        },
    ];
}
